import styled from "styled-components";
import InkShape from "../../Assets/images/static/ink.png";
export const Styles = styled.div`
  .login-page {
    display: flex;
    color: #282c34;
    position: relative;
    z-index: 1;
    width: 100%;
  }
  .login-page .login-logo {
    min-height: 100vh;
    width: 50%;
    background: ${({ themeMode }) =>
      themeMode === "dark"
        ? "linear-gradient(to right, #05162b, #114787)"
        : "linear-gradient(to right, #f5fafd, #114787)"};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;
    &::after {
      content: "";
      position: absolute;
      width: 280px;
      height: 220px;
      background: url(${InkShape});
      background-size: contain;
      background-repeat: no-repeat;
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 300;
      mix-blend-mode: color-burn;
    }
    img {
      width: 200px;
      height: 200px;
      z-index: 3000;
      object-fit: contain;
    }
  }
  .login-page .login-form {
    position: relative;
    min-height: 100vh;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    form {
      margin-bottom: 18px;
      font-size: 1.1rem;
      .form-control {
        width: 100%;
        font-size: 1.1rem !important;
      }
      .forget-password {
        font-size: 1rem;
        font-weight: 400;

        display: block;
        text-align: end;
        a {
          color: var(--main-color);
        }
      }
      .btn {
        width: 100%;
        margin-bottom: 10px !important;
        border-radius: 3px;
        font-size: 1.1rem;
        font-weight: 600;
      }
    }
  }
  @media (max-width: 767px) {
    .login-page .login-logo {
      display: none;
    }
    .login-page .login-form {
      width: 100%;
      background: transparent;
    }
  }
`;
